import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import sanitizedContentData from '../../shared/utils/sanitizedContentData'
import './styles.scss'
import { InViewSimpleTransition } from '../../shared/utils/animations/transitions'

ContentGrid.propTypes = {
  data: PropTypes.object,
}
export default function ContentGrid({ data }) {
  const targetRef = useRef(null)
  /*
   *   Insert your logic here
   */
  const grid_content = {
    top_title: data?.top_title ?? '',
    main_title: data?.main_title ?? '',
    grid_content_block: Array.isArray(data?.grid_content_block) ? data?.grid_content_block : [],
    background_color: data?.background_color ?? 'bk_isabelline',
  }
  return (
    <div className={`ContentGrid contentGrid_${grid_content.background_color}`}>
      <InViewSimpleTransition parent={targetRef} type="fade">
        <div ref={targetRef} className="main-grid-container">
          <div className="title-block">
            <pre>{grid_content.top_title}</pre>
            <h2>{grid_content.main_title}</h2>
          </div>
          <div className="grid-content-block">
            {grid_content.grid_content_block.map((item, index) => {
              return (
                <div className="grid-content-block-item" key={index}>
                  <h3>
                    <span className="numberIcon">{(index + 1).toString().padStart(2, '0')}</span>{' '}
                    {item.title}
                  </h3>
                  <div
                    className="grid-content-block-item-paragraph"
                    dangerouslySetInnerHTML={sanitizedContentData(item.content)}
                  ></div>
                </div>
              )
            })}
          </div>
        </div>
      </InViewSimpleTransition>
    </div>
  )
}
